import Props from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';

function PaginationDot({ focused }: Props) {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        version='1.1'
        width={14 * Screen.widthRatio}
        height={14 * Screen.widthRatio}
      >
        <circle
          cx={7 * Screen.widthRatio}
          cy={7 * Screen.widthRatio}
          r={7 * Screen.widthRatio}
          fill={focused ? '#ffffff' : '#ffffff80'}
        />
      </svg>
    </>
  );
}

export default PaginationDot;
